/**
 * @fileoverview API layer for Energy Source settings. All endpoint knowledge for
 * this feature lives here; components call these named functions and never
 * assemble URLs themselves.
 */
import { apiCall } from "../../../_services/apiCall";
import config from "../../../config/config";

const COMPANY = config.POSTLOGIN_API_URL_COMPANY;

/**
 * Fetch the list of available energy sources.
 * @returns {Promise<object>} apiCall result whose data holds the source list.
 */
export const getEnergySources = () =>
  apiCall(`${COMPANY}energy/sources`, {}, {}, "GET");

/**
 * Fetch the KPI → energy-source mappings for a financial year.
 * @param {number} fyid Financial year id.
 * @returns {Promise<object>} apiCall result whose data.data holds mappings + kpiSourceMap.
 */
export const getKpiSourceMappings = (fyid) =>
  apiCall(`${COMPANY}energyKpiSettings/kpiSourceMappings`, {}, { fyid }, "GET");

/**
 * Fetch the company's frameworks.
 * @param {number} userId System user id.
 * @returns {Promise<object>} apiCall result whose data.data holds frameworks.
 */
export const getFrameworks = (userId) =>
  apiCall(`${COMPANY}getFramework`, {}, { type: "ALL", userId }, "GET");

/**
 * Fetch reporting questions (KPIs) for a financial year + framework set.
 * @param {number} financialYearId Financial year id.
 * @param {number[]} frameworkIds Framework ids to include.
 * @returns {Promise<object>} apiCall result whose data.data holds the questions.
 */
export const getReportingQuestions = (financialYearId, frameworkIds) =>
  apiCall(
    `${COMPANY}getReportingQuestionnew`, {},
    { financialYearId, frameworkIds, fromSettings: false },
    "GET",
  );

/**
 * Bulk save KPI → energy-source mappings (changed entries only; null = remove).
 * @param {number} fyid Financial year id.
 * @param {Array<{kpiId:number, energySourceId:(number|null)}>} mappings Changed mappings.
 * @returns {Promise<object>} apiCall result whose data holds { success, message }.
 */
export const saveKpiSourceMappings = (fyid, mappings) =>
  apiCall(`${COMPANY}energyKpiSettings/kpiSourceMappings`, {}, { fyid: Number(fyid), mappings }, "POST");
